import { styled } from 'styled-components';

import { colors, cssBreakpoints } from '#/theme/theme';

export const CompensationSurveyFields_Box_1 = styled.div`
  padding-block: 12px;
  padding-inline: 24px;
  margin-top: -22px;
  margin-bottom: 30px;
  background: ${colors.backgroundGrey};
  border-radius: 8px;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    padding-block: 24px;
    padding-inline: 44px;
  }
`;
